import * as React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Header, Modal } from "semantic-ui-react";
import { Text } from "../components/common";
import { FILES_PATH } from "../constants";

interface IM003RegisterDocumentsDownload extends WithTranslation {
  trigger: any;
}

class M003RegisterDocumentsDownload extends React.Component<
  IM003RegisterDocumentsDownload
> {
  public render() {
    const { t } = this.props;
    return (
      <React.Fragment>
        <Modal trigger={this.props.trigger} closeIcon size={"small"}>
          <Modal.Header>
            <Header shade={2} textAlign={"center"}>
              {t("modal.M003RegisterDocumentsDownload.header")}
            </Header>
          </Modal.Header>
          <Modal.Content scrolling style={styles.modalContentStyle}>
            <Modal.Description style={styles.modalDescriptionStyle}>
              <div>
                <Text shade={3} style={styles.spanStyle}>
                  <Link
                    target="_blank"
                    to={FILES_PATH.DocumentForRequestingOccupationLoan}
                    download
                    style={styles.link}
                  >
                    <Text
                      id={"link-label-m003-download-doc1"}
                      underline
                      shade={5}
                    >
                      {t("modal.M003RegisterDocumentsDownload.doc1")}
                    </Text>
                  </Link>
                </Text>
              </div>
              <div>
                <Text shade={3} style={styles.spanStyle}>
                  <Link
                    target="_blank"
                    to={FILES_PATH.DocumentForHouseMapAndWorkplace}
                    download
                    style={styles.link}
                  >
                    <Text
                      id={"link-label-m003-download-doc2"}
                      underline
                      shade={5}
                    >
                      {t("modal.M003RegisterDocumentsDownload.doc2")}
                    </Text>
                  </Link>
                </Text>
              </div>
              <div>
                <Text shade={3} style={styles.spanStyle}>
                  <Link
                    target="_blank"
                    to={FILES_PATH.MemorandumDocument}
                    download
                    style={styles.link}
                  >
                    <Text
                      id={"link-label-m003-download-doc3"}
                      underline
                      shade={5}
                    >
                      {t("modal.M003RegisterDocumentsDownload.doc3")}
                    </Text>
                  </Link>
                </Text>
              </div>
              <div>
                <Text shade={3} style={styles.spanStyle}>
                  <Link
                    target="_blank"
                    to={FILES_PATH.SpouseConsentLetterBorrower}
                    download
                    style={styles.link}
                  >
                    <Text
                      id={"link-label-m003-download-doc4"}
                      underline
                      shade={5}
                    >
                      {t("modal.M003RegisterDocumentsDownload.doc4")}
                    </Text>
                  </Link>
                </Text>
              </div>
              <div>
                <Text shade={3} style={styles.spanStyle}>
                  <Link
                    target="_blank"
                    to={FILES_PATH.SpouseConsentLetterGuarantor}
                    download
                    style={styles.link}
                  >
                    <Text
                      id={"link-label-m003-download-doc5"}
                      underline
                      shade={5}
                    >
                      {t("modal.M003RegisterDocumentsDownload.doc5")}
                    </Text>
                  </Link>
                </Text>
              </div>
            </Modal.Description>
          </Modal.Content>
        </Modal>
      </React.Fragment>
    );
  }
}

const styles: any = {
  spanStyle: {
    // whiteSpace: "pre-wrap",
    whiteSpace: "pre-line"
  },
  addressStyle: {
    marginLeft: 42
  },
  displayInline: {
    display: "inline"
  },
  modalDescriptionStyle: {
    lineHeight: 1.8
  },
  modalContentStyle: {
    padding: 42
  },
  link: {
    opacity: "inherit"
  }
};

export default withTranslation()(M003RegisterDocumentsDownload);
